import { useEffect, useState, useMemo } from 'react';
import _debounce from 'lodash/debounce';
/**
 * Creates a debounced listener to the 'resize' event, which will force the component calling it to re-render after 500ms.
 */
export function useForceUpdateOnWindowResize(): void {
  // Extract the setter func from index 1 of the array returned by useState().
  const [, forceUpdate] = useState<Event>();
  // If invoked multiple times, _debounce returns the result of the func passed to it until the wait time is exceeded.
  // Once the wait time is exceeded, the result of _debounce will have a new reference.
  const debounceFn = useMemo(() => _debounce(forceUpdate, 500), [forceUpdate]);
  useEffect(
    () => {
      window.addEventListener('resize', debounceFn);
      return () => {
        window.removeEventListener('resize', debounceFn);
      };
    },
    // Because we memoized the debounce func, it will only invoke useEffect once the timeout completes.
    [debounceFn]
  );
}

export default useForceUpdateOnWindowResize;
